module.exports = __webpack_public_path__ + "components/country-flag/static/gb-wls-e875b0f28a6ec14062ed2b5d9f52e38e.svg";